<script>
    export default {
        props: {
            initialFiberWorkPhase: {
                type: Object,
                required: true,
            },
        },

        data() {
            return {
                fiberWorkPhase: this.initialFiberWorkPhase,
            };
        },

        methods: {
            updateFiberWorkPhase() {
                window.location = window.location.href;
            },
        },
    };
</script>
